import { render } from "./TetherResult.vue?vue&type=template&id=901ef122&scoped=true&ts=true"
import script from "./TetherResult.vue?vue&type=script&lang=ts"
export * from "./TetherResult.vue?vue&type=script&lang=ts"

import "./TetherResult.vue?vue&type=style&index=0&id=901ef122&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-901ef122"]])

export default __exports__